import * as pdfjsLib from "pdfjs-dist";
import pdfWorker from "pdfjs-dist/build/pdf.worker.min.mjs?url";

import { log } from "utils/log";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

const l = log.miniMap.utils;

export async function fetchDrawingData(url: string, signal?: AbortSignal): Promise<ImageBitmap> {
    l.debug("fetchDrawingData:", url);

    // Scale the image to a large resolution while it's still potentially a
    // vector-based format.
    const imgWidth = 6212;
    const imgHeight = 4800;

    const response = await fetch(url, { signal });
    if (!response.ok) {
        throw new Error(`Failed to fetch drawing data: HTTP ${response.status} for ${url}`);
    }
    const arrayBuffer = await response.arrayBuffer();
    const pdfDoc = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    const page = await pdfDoc.getPage(1);

    const viewport = page.getViewport({ scale: 1 });
    let scale: number;
    if (viewport.width > viewport.height) {
        scale = imgWidth / viewport.width;
    } else {
        scale = imgHeight / viewport.height;
    }
    const scaledViewport = page.getViewport({ scale: scale });

    const offscreenCanvas = new OffscreenCanvas(scaledViewport.width, scaledViewport.height);
    const context = offscreenCanvas.getContext("2d");
    if (!context) {
        throw new Error("Failed to create canvas context");
    }
    const renderContext = {
        canvasContext: context,
        viewport: scaledViewport,
    };

    // @ts-expect-error - the type is overly restrictive
    // and does not allow an
    // OffscreenCanvasRenderingContext2D, even though it
    // works in practice
    const renderTask = page.render(renderContext);
    await renderTask.promise;
    await pdfDoc.destroy();

    const pngBlob = await offscreenCanvas.convertToBlob({ type: "image/png" });

    const imgBitmap = await createImageBitmap(pngBlob);
    return imgBitmap;
}
